// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { xPartNumberStyle } from '@plumberssupply/App/SharedStyle/ProductPartNumberStyle';
import { mergeWithCss, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

partNumberStyles.labelText = {
    ...mergeWithCss(xPartNumberStyle.label, {
        size: 16,
        weight: 800,
        css: css`
            line-height: 26px;
            ${xScreen("lte", "md")} {
                line-height: 22px;
                font-size: 14px;
            }
        `,
    })
};

partNumberStyles.valueText = {
    ...mergeWithCss(xPartNumberStyle.value, {
        size: 16,
        css: css`
            margin-bottom: 4px;
            ${xScreen("lte", "md")} {
                line-height: 22px;
                font-size: 14px;
            }
        `,
    })
};